import { render } from "./SeoHead.vue?vue&type=template&id=a691b70a"
import script from "./SeoHead.vue?vue&type=script&lang=js"
export * from "./SeoHead.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__